import { tracked } from '@glimmer/tracking';
import Constants from '../utils/constants';

export default class ChartHandler {
  @tracked data = {};
  @tracked current = {};

  constructor() {}

  update(type) {
    if (type in this.current && this.current[type]) {
      this.current[type].draw();
    }
  }

  handleDacTypeChange() {
    const data = {};
    const current = {};
    Object.values(Constants.CHART_TYPES).forEach((chartType) => {
      data[chartType] = {};
      current[chartType] = null;
    });
    this.data = data;
    this.current = current;
  }
}
